import { gql } from '@apollo/client';
import axios from 'axios';
import { apolloClient } from '../apollo/client';
import { dispatchGlobalError } from '../context/ApiErrorContext';
import { dispatchLogout } from '../context/AuthContext';
import { Expand } from 'react-ionicons';


const restUrl = process.env.REACT_APP_GRAPHQL_ENDPOINT + "api/";

export interface PostInput {
  texto: string;
  autorAtletaId?: string;
  autorTorneioId?: string;
  autorLigaId?: string;
  partidaId?: string;
}

export const criarPost = async (
  input: PostInput,
  arquivos: File[]
): Promise<Post> => {
  const formData = new FormData();
  Object.entries(input).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  arquivos.forEach((file) => {
    formData.append('arquivos', file);
  });

  const token = localStorage.getItem('token');
  const headers: Record<string, string> = {};
  if (token) {
    headers['authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await axios.post<Post>(
      `${restUrl}posts`,
      formData,
      { headers }
    );
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 401) {
      dispatchLogout();
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
      throw error;
    }

    let message = 'Erro inesperado. Tente novamente.';
    if (error.response?.data?.message) {
      message = error.response.data.message;
    } else if (error.message) {
      message = error.message;
    }
    dispatchGlobalError(message);
    throw error;
  }
};

export const LISTAR_POSTS = gql`
  query posts($page: Int!, $size: Int!, $curtidorAtletaId: ID, $curtidorTorneioId: ID) {
    posts(page: $page, size: $size, sortBy: "criadoEm", direction: "DESC", curtidorAtletaId: $curtidorAtletaId, curtidorTorneioId: $curtidorTorneioId) {
      id
      texto
      criadoEm
      status
      jaCurtido
      autorAtleta {
        id
        usuario {
          id
          username
          nome
          imagemUrl
        }
      }
      autorTorneio {
        id
        nome
        username
      }
      autorLiga {
        id
        nome
        imagemUrl
        username
      }
      midias {
        id
        ordem
        tipo
        url
      }
      curtidasCount
      comentarios {
        id
        criadoEm
        texto
        curtidasCount
        jaCurtiu
        autorAtleta {
          id
          usuario {
            id
            nome
            username
            imagemUrl
          }
        }
        autorTorneio {
          avatarUrl
          id
          nome
          username
        }
        autorLiga {
          id
          nome
          imagemUrl
          username
        }
      }
      comentariosCount
      partida {
        id
        data
        local { id nome }
        placar {
          resultadoFinalA
          resultadoFinalB
          sets { numeroSet gamesA gamesB }
        }
        equipeA {
          id nome
          atletas { id usuario { id nome imagemUrl } }
        }
        equipeB {
          id nome
          atletas { id usuario { id nome imagemUrl } }
        }
        participantesA { id usuario { id nome imagemUrl } }
        participantesB { id usuario { id nome imagemUrl } }
        categoriaTorneio {
          id
          nome
          torneio { id nome avatarUrl }
        }
      }
    }
  }
`;

export const POSTS_POR_USUARIO = gql`
  query PostsPorUsuario($usuarioId: ID!, $page: Int!, $size: Int!, $curtidorAtletaId: ID, $curtidorTorneioId: ID) {
    postsPorUsuario(
      usuarioId: $usuarioId
      page: $page
      size: $size
      sortBy: "criadoEm"
      direction: "DESC"
      curtidorAtletaId: $curtidorAtletaId
      curtidorTorneioId: $curtidorTorneioId
    ) {
      page
      size
      totalItems
      totalPages
      items {
        jaCurtido
        atualizadoEm
        criadoEm
        status
        id
        autorAtleta {
          id
          usuario {
            id
            nome
            username
            imagemUrl
          }
        }
        autorTorneio {
          id
          nome
          username
        }
        autorLiga {
          id
          nome
          imagemUrl
          username
        }
        texto
        midias {
          id
          ordem
          tipo
          url
        }
        curtidasCount
        comentarios {
          id
          criadoEm
          texto
          curtidasCount
          jaCurtiu
          autorAtleta {
            id
            usuario {
              id
              nome
              imagemUrl
              username
            }
          }
          autorTorneio {
            avatarUrl
            id
            nome
            username
          }
          autorLiga {
            id
            nome
            imagemUrl
            username
          }
        }
        comentariosCount
        partida {
          id
          data
          local { id nome }
          placar {
            resultadoFinalA
            resultadoFinalB
            sets { numeroSet gamesA gamesB }
          }
          equipeA {
            id nome
            atletas { id usuario { id nome imagemUrl } }
          }
          equipeB {
            id nome
            atletas { id usuario { id nome imagemUrl } }
          }
          participantesA { id usuario { id nome imagemUrl } }
          participantesB { id usuario { id nome imagemUrl } }
          categoriaTorneio {
            id
            nome
            torneio { id nome avatarUrl }
          }
        }
      }
    }
  }
`;

export const POSTS_POR_ATLETA = gql`
  query PostsPorAtleta($atletaId: ID!, $page: Int!, $size: Int!, $curtidorAtletaId: ID, $curtidorTorneioId: ID) {
    postsPorAtleta(
      atletaId: $atletaId
      page: $page
      size: $size
      sortBy: "criadoEm"
      direction: "DESC"
      curtidorAtletaId: $curtidorAtletaId
      curtidorTorneioId: $curtidorTorneioId
    ) {
      page
      size
      totalItems
      totalPages
      items {
        jaCurtido
        atualizadoEm
        criadoEm
        status
        id
        autorAtleta {
          id
          usuario {
            id
            nome
            username
            imagemUrl
          }
        }
        autorTorneio {
          id
          nome
          username
        }
        autorLiga {
          id
          nome
          imagemUrl
          username
        }
        texto
        midias {
          id
          ordem
          tipo
          url
        }
        curtidasCount
        comentarios {
          id
          criadoEm
          texto
          curtidasCount
          jaCurtiu
          autorAtleta {
            id
            usuario {
              id
              nome
              imagemUrl
              username
            }
          }
          autorTorneio {
            avatarUrl
            id
            nome
            username
          }
          autorLiga {
            id
            nome
            imagemUrl
            username
          }
        }
        comentariosCount
        partida {
          id
          data
          local { id nome }
          placar {
            resultadoFinalA
            resultadoFinalB
            sets { numeroSet gamesA gamesB }
          }
          equipeA {
            id nome
            atletas { id usuario { id nome imagemUrl } }
          }
          equipeB {
            id nome
            atletas { id usuario { id nome imagemUrl } }
          }
          participantesA { id usuario { id nome imagemUrl } }
          participantesB { id usuario { id nome imagemUrl } }
          categoriaTorneio {
            id
            nome
            torneio { id nome avatarUrl }
          }
        }
      }
    }
  }
`;

export const POSTS_POR_TORNEIO = gql`
  query PostsPorTorneio($torneioId: ID!, $page: Int!, $size: Int!, $curtidorAtletaId: ID, $curtidorTorneioId: ID, $curtidorLigaId: ID) {
    postsPorTorneio(
      torneioId: $torneioId
      page: $page
      size: $size
      sortBy: "criadoEm"
      direction: "DESC"
      curtidorAtletaId: $curtidorAtletaId
      curtidorTorneioId: $curtidorTorneioId
      curtidorLigaId: $curtidorLigaId
    ) {
      page
      size
      totalItems
      totalPages
      items {
        jaCurtido
        atualizadoEm
        criadoEm
        status
        id
        autorAtleta {
          id
          usuario {
            id
            nome
            username
            imagemUrl
          }
        }
        autorTorneio {
          id
          nome
          username
        }
        autorLiga {
          id
          nome
          imagemUrl
          username
        }
        texto
        midias {
          id
          ordem
          tipo
          url
        }
        curtidasCount
        comentarios {
          id
          criadoEm
          texto
          curtidasCount
          jaCurtiu
          autorAtleta {
            id
            usuario {
              id
              nome
              imagemUrl
              username
            }
          }
          autorTorneio {
            avatarUrl
            id
            nome
            username
          }
          autorLiga {
            id
            nome
            imagemUrl
            username
          }
        }
        comentariosCount
        partida {
          id
          data
          local { id nome }
          placar {
            resultadoFinalA
            resultadoFinalB
            sets { numeroSet gamesA gamesB }
          }
          equipeA {
            id nome
            atletas { id usuario { id nome imagemUrl } }
          }
          equipeB {
            id nome
            atletas { id usuario { id nome imagemUrl } }
          }
          participantesA { id usuario { id nome imagemUrl } }
          participantesB { id usuario { id nome imagemUrl } }
          categoriaTorneio {
            id
            nome
            torneio { id nome avatarUrl }
          }
        }
      }
    }
  }
`;

export const POSTS_POR_LIGA = gql`
  query PostsPorLiga($ligaId: ID!, $page: Int!, $size: Int!, $curtidorAtletaId: ID, $curtidorTorneioId: ID, $curtidorLigaId: ID) {
    postsPorLiga(
      ligaId: $ligaId
      page: $page
      size: $size
      sortBy: "criadoEm"
      direction: "DESC"
      curtidorAtletaId: $curtidorAtletaId
      curtidorTorneioId: $curtidorTorneioId
      curtidorLigaId: $curtidorLigaId
    ) {
      page
      size
      totalItems
      totalPages
      items {
        jaCurtido
        atualizadoEm
        criadoEm
        status
        id
        autorAtleta {
          id
          usuario {
            id
            nome
            username
            imagemUrl
          }
        }
        autorTorneio {
          id
          nome
          username
        }
        autorLiga {
          id
          nome
          imagemUrl
          username
        }
        texto
        midias {
          id
          ordem
          tipo
          url
        }
        curtidasCount
        comentarios {
          id
          criadoEm
          texto
          curtidasCount
          jaCurtiu
          autorAtleta {
            id
            usuario {
              id
              nome
              imagemUrl
              username
            }
          }
          autorTorneio {
            avatarUrl
            id
            nome
            username
          }
          autorLiga {
            id
            nome
            imagemUrl
            username
          }
        }
        comentariosCount
        partida {
          id
          data
          local { id nome }
          placar {
            resultadoFinalA
            resultadoFinalB
            sets { numeroSet gamesA gamesB }
          }
          equipeA {
            id nome
            atletas { id usuario { id nome imagemUrl } }
          }
          equipeB {
            id nome
            atletas { id usuario { id nome imagemUrl } }
          }
          participantesA { id usuario { id nome imagemUrl } }
          participantesB { id usuario { id nome imagemUrl } }
          categoriaTorneio {
            id
            nome
            torneio { id nome avatarUrl }
          }
        }
      }
    }
  }
`;

export interface Comentario {
  id: string;
  criadoEm: string;
  texto: string;
  curtidasCount?: number;
  jaCurtiu?: boolean;
  autorAtleta?: {
    id: string;
    usuario: {
      id: string;
      nome: string;
      imagemUrl?: string;
      username?: string;
    };
  } | null;
  autorTorneio?: {
    avatarUrl?: string;
    id: string;
    nome: string;
    username?: string;
  } | null;
  autorLiga?: {
    id: string;
    nome: string;
    imagemUrl?: string | null;
    username?: string | null;
  } | null;
}

export interface PartidaResumo {
  id: string;
  /** Campo 'data' no schema GraphQL (tipo DateTime) — nome exato confirmado em partida.graphqls */
  data?: string | null;
  local?: { id: string; nome: string } | null;
  placar?: {
    resultadoFinalA?: number | null;
    resultadoFinalB?: number | null;
    sets: { numeroSet: number; gamesA: number | null; gamesB: number | null }[];
  } | null;
  equipeA?: {
    id: string;
    nome: string;
    atletas: { id: string; usuario: { id: string; nome: string; imagemUrl?: string | null } }[];
  } | null;
  equipeB?: {
    id: string;
    nome: string;
    atletas: { id: string; usuario: { id: string; nome: string; imagemUrl?: string | null } }[];
  } | null;
  participantesA?: { id: string; usuario?: { id: string; nome?: string | null; imagemUrl?: string | null } | null }[] | null;
  participantesB?: { id: string; usuario?: { id: string; nome?: string | null; imagemUrl?: string | null } | null }[] | null;
  categoriaTorneio?: {
    id: string;
    nome?: string | null;
    torneio: { id: string; nome: string; avatarUrl?: string | null };
  } | null;
}

export interface Post {
  id: string;
  texto: string;
  criadoEm: string;
  atualizadoEm?: string;
  status?: StatusPost;
  jaCurtido?: boolean;
  midias?: {
    id: string;
    ordem: number;
    tipo: string;
    url: string;
  }[];
  curtidasCount?: number;
  autorAtleta?: {
    id: string;
    usuario: {
      id: string;
      nome: string;
      username?: string;
      imagemUrl?: string;
    };
  } | null;
  autorTorneio?: {
    id: string;
    nome: string;
    avatarUrl: string;
    username?: string;
  } | null;
  autorLiga?: {
    id: string;
    nome: string;
    imagemUrl?: string | null;
    username?: string | null;
  } | null;
  comentarios?: Comentario[];
  comentariosCount?: number;
  partida?: PartidaResumo | null;
}

export type StatusPost = 'ATIVO' | 'INATIVO' | 'APROVADO' | 'REPROVADO' | 'PENDENTE';

export interface ListarPostsVars {
  page: number;
  size: number;
  curtidorAtletaId?: string;
  curtidorTorneioId?: string;
}

export interface ListarPostsResponse {
  posts: Post[];
}

export interface PostsPorUsuarioVars {
  usuarioId: string;
  page: number;
  size: number;
  curtidorAtletaId?: string;
  curtidorTorneioId?: string;
}

export interface PostsPorUsuarioData {
  postsPorUsuario: {
    page: number;
    size: number;
    totalItems: number;
    totalPages: number;
    items: Post[];
  };
}

export interface PostsPorAtletaVars {
  atletaId: string;
  page: number;
  size: number;
  curtidorAtletaId?: string;
  curtidorTorneioId?: string;
}

export interface PostsPorTorneioVars {
  torneioId: string;
  page: number;
  size: number;
  curtidorAtletaId?: string;
  curtidorTorneioId?: string;
  curtidorLigaId?: string;
}

export interface PostsPorAtletaData {
  postsPorAtleta: {
    page: number;
    size: number;
    totalItems: number;
    totalPages: number;
    items: Post[];
  };
}

export interface PostsPorTorneioData {
  postsPorTorneio: {
    page: number;
    size: number;
    totalItems: number;
    totalPages: number;
    items: Post[];
  };
}

export interface PostsPorLigaVars {
  ligaId: string;
  page: number;
  size: number;
  curtidorAtletaId?: string;
  curtidorTorneioId?: string;
  curtidorLigaId?: string;
}

export interface PostsPorLigaData {
  postsPorLiga: {
    page: number;
    size: number;
    totalItems: number;
    totalPages: number;
    items: Post[];
  };
}

export const POST_POR_ID = gql`
  query PostPorId($id: ID!, $curtidorAtletaId: ID, $curtidorTorneioId: ID, $curtidorLigaId: ID) {
    postPorId(id: $id, curtidorAtletaId: $curtidorAtletaId, curtidorTorneioId: $curtidorTorneioId, curtidorLigaId: $curtidorLigaId) {
      jaCurtido
      atualizadoEm
      criadoEm
      status
      id
      autorAtleta {
        id
        usuario { id nome username imagemUrl }
      }
      autorTorneio { id nome username }
      autorLiga { id nome imagemUrl username }
      texto
      midias { id ordem tipo url }
      curtidasCount
      comentarios {
        id
        criadoEm
        texto
        curtidasCount
        jaCurtiu
        autorAtleta {
          id
          usuario { id nome imagemUrl username }
        }
        autorTorneio { avatarUrl id nome username }
        autorLiga { id nome imagemUrl username }
      }
      comentariosCount
      partida {
        id
        data
        local { id nome }
        placar {
          resultadoFinalA
          resultadoFinalB
          sets { numeroSet gamesA gamesB }
        }
        equipeA {
          id nome
          atletas { id usuario { id nome imagemUrl } }
        }
        equipeB {
          id nome
          atletas { id usuario { id nome imagemUrl } }
        }
        participantesA { id usuario { id nome imagemUrl } }
        participantesB { id usuario { id nome imagemUrl } }
        categoriaTorneio {
          id
          nome
          torneio { id nome avatarUrl }
        }
      }
    }
  }
`;

export interface PostPorIdData {
  postPorId: Post | null;
}

export interface PostPorIdVars {
  id: string;
  curtidorAtletaId?: string;
  curtidorTorneioId?: string;
  curtidorLigaId?: string;
}

export const listarPosts = async (page: number, size: number, curtidorAtletaId: string, curtidorTorneioId: string) => {
  console.log('Fetching posts with page:', page, 'and size:', size);
  const { data } = await apolloClient.query<ListarPostsResponse, ListarPostsVars>({
    query: LISTAR_POSTS,
    variables: { page, size, curtidorAtletaId, curtidorTorneioId },
    fetchPolicy: 'no-cache',
  });
  console.log('Posts fetched:', data.posts);
  return data.posts;
};

export const listarPostsPorUsuario = async (
  usuarioId: string,
  page: number,
  size: number,
  curtidorAtletaId?: string,
  curtidorTorneioId?: string
) => {
  const { data } = await apolloClient.query<
    PostsPorUsuarioData,
    PostsPorUsuarioVars
  >({
    query: POSTS_POR_USUARIO,
    variables: { usuarioId, page, size, curtidorAtletaId, curtidorTorneioId },
    fetchPolicy: 'no-cache',
  });
  return data.postsPorUsuario;
};

export const listarPostsPorAtleta = async (
  atletaId: string,
  page: number,
  size: number,
  curtidorAtletaId?: string,
  curtidorTorneioId?: string
) => {
  const { data } = await apolloClient.query<
    PostsPorAtletaData,
    PostsPorAtletaVars
  >({
    query: POSTS_POR_ATLETA,
    variables: { atletaId, page, size, curtidorAtletaId, curtidorTorneioId },
    fetchPolicy: 'no-cache',
  });
  return data.postsPorAtleta;
};

export const listarPostsPorTorneio = async (
  torneioId: string,
  page: number,
  size: number,
  curtidorAtletaId?: string,
  curtidorTorneioId?: string,
  curtidorLigaId?: string
) => {
  const { data } = await apolloClient.query<
    PostsPorTorneioData,
    PostsPorTorneioVars
  >({
    query: POSTS_POR_TORNEIO,
    variables: { torneioId, page, size, curtidorAtletaId, curtidorTorneioId, curtidorLigaId },
    fetchPolicy: 'no-cache',
  });
  return data.postsPorTorneio;
};

export const listarPostsPorLiga = async (
  ligaId: string,
  page: number,
  size: number,
  curtidorAtletaId?: string,
  curtidorTorneioId?: string,
  curtidorLigaId?: string
) => {
  const { data } = await apolloClient.query<
    PostsPorLigaData,
    PostsPorLigaVars
  >({
    query: POSTS_POR_LIGA,
    variables: { ligaId, page, size, curtidorAtletaId, curtidorTorneioId, curtidorLigaId },
    fetchPolicy: 'no-cache',
  });
  return data.postsPorLiga;
};

export const postPorId = async (
  id: string,
  curtidorAtletaId?: string,
  curtidorTorneioId?: string,
  curtidorLigaId?: string,
) => {
  const { data } = await apolloClient.query<PostPorIdData, PostPorIdVars>({
    query: POST_POR_ID,
    variables: { id, curtidorAtletaId, curtidorTorneioId, curtidorLigaId },
    fetchPolicy: 'no-cache',
  });
  return data.postPorId;
};

export const ALTERAR_STATUS_POST = gql`
  mutation AlterarStatusPost($id: ID!, $status: StatusPost!) {
    alterarStatusPost(id: $id, status: $status) {
      id
      status
      atualizadoEm
    }
  }
`;

export interface AlterarStatusPostVars {
  id: string;
  status: StatusPost;
}

export interface AlterarStatusPostData {
  alterarStatusPost: Post;
}

export const alterarStatusPost = async (id: string, status: StatusPost): Promise<Post> => {
  const { data } = await apolloClient.mutate<AlterarStatusPostData, AlterarStatusPostVars>({
    mutation: ALTERAR_STATUS_POST,
    variables: { id, status },
  });
  return data!.alterarStatusPost;
};

// --- Deletar Post ---
export const DELETAR_POST = gql`
  mutation DeletarPost($id: ID!) {
    deletarPost(id: $id)
  }
`;

export const deletarPost = async (postId: string): Promise<void> => {
  await apolloClient.mutate({
    mutation: DELETAR_POST,
    variables: { id: postId },
  });
};

export const CATEGORIAS_TORNEIO_POR_ATLETA = gql`
  query categoriaTorneioPorAtleta($idAtleta: ID!, $statusInscricao: StatusInscricao!) {
    categoriaTorneioPorAtleta(idAtleta: $idAtleta, statusInscricao: $statusInscricao) {
      id
      nome
      aplicarDescontoTorneio
    }
  }
`;

export interface CategoriaTorneioPorAtletaVars {
  idAtleta: string;
  statusInscricao: string;
}

export interface CategoriaTorneioPorAtletaData {
  categoriaTorneioPorAtleta: { id: string; nome: string }[];
}

export const categoriaTorneioPorAtleta = async (
  idAtleta: string,
  statusInscricao: string
) => {
  const { data } = await apolloClient.query<
    CategoriaTorneioPorAtletaData,
    CategoriaTorneioPorAtletaVars
  >({
    query: CATEGORIAS_TORNEIO_POR_ATLETA,
    variables: { idAtleta, statusInscricao },
    fetchPolicy: 'no-cache',
  });
  return data.categoriaTorneioPorAtleta;
};
